// extracted by mini-css-extract-plugin
export default {"header-info":"page-header_header-info__VdW-0","title":"page-header_title__mHrU-","icon":"page-header_icon__JXOkx"};